import { render } from "./dataLoder.vue?vue&type=template&id=11a4ad4f"
import script from "./dataLoder.vue?vue&type=script&lang=js"
export * from "./dataLoder.vue?vue&type=script&lang=js"

import "./dataLoder.vue?vue&type=style&index=0&id=11a4ad4f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__